// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooterMobile_footer__FBVJL","gradient":"AppFooterMobile_gradient__vhpcU"};